/**
 * slider
 */

import $ from 'jquery';
import anime from 'animejs';
import 'slick-carousel';

import Page from 'js/lib/page';

export default class Slider extends Page {
  constructor(element) {
    super(element);
  }
  init() {
    const options = this.$.root.data('options');

    this.animation = {
      DURATION: options.duration || 600,
      OFFSET: options.offset || 300,
      EASING: options.easing || 'easeOutQuad'
    };

    this.elements({
      slider: '.js-slider-slides',
      slide: '.js-slider-slide',
      prev: '.js-slider-prev',
      next: '.js-slider-next'
    });

    this.events({
      'init.slider': {
        target: this.$.slider,
        handler: () => this.mount()
      },
      'click.prev.slider': {
        target: this.$.prev,
        data: { type: 'PREV' },
        handler: e => this.handler(e)
      },
      'click.next.slider': {
        target: this.$.next,
        data: { type: 'NEXT' },
        handler: e => this.handler(e)
      }
    });

    this.slick();
  }
  slick() {
    this.$.slider.slick({
      arrows: false,
      slidesToShow: 1,
      infinite: true,
      fade: true,
      swipe: false,
      accessibility: false
    });
  }
  handler(e) {
    const $target = $(e.target);

    const type = e.data.type;
    const map = {
      PREV: () => this.go('slickPrev'),
      NEXT: () => this.go('slickNext')
    };

    map[type].call(null);
  }
  go(dir) {
    this.out().then(() => {
      this.$.slider.slick(dir);
      this.in();
    });
  }
  in() {
    const deferred = $.Deferred();
    const timeline = this.getTimeline();

    timeline.complete = () => {
      deferred.resolve();
    };

    return deferred.promise();
  }
  out() {
    const deferred = $.Deferred();

    setTimeout(() => {
      deferred.resolve();
    }, 200);

    return deferred.promise();
  }
  getTimeline() {
    const $current = this.getSlide();
    const $elements = $current.find('[data-animate]');

    const timeline = anime.timeline({ delay: 200 });
    const easing = this.animation.EASING;

    $elements.each((i, element) => {
      const $element = $(element);
      const data = $element.data('animate');
      const from = data.keyframes.from || { opacity: 0 };
      const to = data.keyframes.to || { opacity: 1 };
      const duration = data.duration || this.animation.DURATION;
      const offset = data.offset || this.animation.OFFSET;

      // @ts-ignore
      const keyframes = $.extend({}, ...this.getKeyframes(from, to, duration));

      timeline.add(
        $.extend({}, keyframes, {
          targets: element,
          easing,
          duration,
          offset: i == 0 ? 0 : `-=${offset}`
        })
      );
    });

    return timeline;
  }
  getSlide(index = this.$.slider.slick('slickCurrentSlide')) {
    const $current = this.$.slide.eq(index);

    return $current;
  }
  getKeyframes(from, to, duration) {
    const keys = Object.keys(from);

    return keys.map(key => {
      return {
        [key]: [{ value: from[key], duration: 0 }, { value: to[key], duration }]
      };
    });
  }
  mount() {
    this.hide();
    this.show().then(() => {
      this.in();
    });
  }
  hide() {
    const $slide = this.getSlide(0);
    const $elements = $slide.find('[data-animate]');

    $elements.css({ opacity: 0 });
  }
  show() {
    const deferred = $.Deferred();
    this.$.root.addClass('is-inited');
    this.$.root.one('transitionend', () => deferred.resolve());

    return deferred.promise();
  }
}

Page.make(Slider, '.js-slider');
